const validateUrl = (url) => {
  try {
    const u = new URL(url);
    return u;
  } catch (err) {
    return false;
  }
};

const discountAjaxCall = async (actionName) => {
  if (!universityPressThemeSettings.wordpressAjaxUrl) {
    return;
  }
  const ajaxUrl = validateUrl(universityPressThemeSettings.wordpressAjaxUrl);

  if (!ajaxUrl) {
    return;
  }

  ajaxUrl.searchParams.set("action", actionName);

  await fetch(ajaxUrl);
};

customElements.whenDefined("foxy-customer-portal").then(async () => {
  const portals = [...document.getElementsByTagName("foxy-customer-portal")];

  portals.forEach((portal) => {
    portal.addEventListener("signin", function () {
      discountAjaxCall("run_login_to_wayland_function");
    });

    portal.addEventListener("signout", function () {
      discountAjaxCall("run_login_to_wayland_function");
    });
  });
});
